export enum EventNames {
    LOGOUT = 'LOGOUT',

    APP_OPEN = 'APP_OPEN',

    FILE_UPLOADED = 'FILE UPLOADED',

    FILE_DELETED = 'FILE DELETED',

    TRANSFORMATION_SAVED = 'TRANSFORMATION SAVED',

    REFER_CLICKED = 'REFER CLICKED',

    SHARE_INVITE_CLICKED = 'SHARE INVITE CLICKED',

    REFERRAL_CODE_COPIED = 'REFERRAL CODE COPIED',

    REFERRAL_URL_COPIED = 'REFERRAL URL COPIED',

    TWITTER_SHARE_CLICKED = 'TWITTER SHARE CLICKED',

    LINKEDIN_SHARE_CLICKED = 'LINKEDIN SHARE CLICKED',

    WHATSAPP_SHARE_CLICKED = 'WHATSAPP SHARE CLICKED',

    FILE_UPLOAD_FROM_HOMEPAGE = 'FILE UPLOAD FROM HOMEPAGE',

    FILE_UPLOAD_FROM_UPLOAD_BUTTON = 'FILE UPLOAD FROM UPLOAD BUTTON',

    FILE_UPLOAD_CLICKED = 'FILE UPLOAD CLICKED',

    FILE_UPLOAD_CLICKED_FROM_STUDIO = 'FILE UPLOAD CLICKED FROM STUDIO',

    FILE_UPLOAD_BY_DRAGGING = 'FILE UPLOAD BY DRAGGING',

    TABLE_VIEW_SELECTED = 'TABLE VIEW SELECTED',

    GRID_VIEW_SELECTED = 'GRID VIEW SELECTED',

    PIXEL_ICON_CLICKED = 'PIXEL ICON CLICKED',

    ACCESS_TOKEN_SUCCESS = 'ACCESS TOKEN SUCCESS',

    LOCAL_ACCESS_TOKEN_SUCCESS = 'LOCAL ACCESS TOKEN SUCCESS',

    GOOGLE_ACCESS_TOKEN_SUCCESS = 'GOOGLE ACCESS TOKEN SUCCESS',

    VERIFY_SIGNUP_TOKEN_SUCCESS = 'VERIFY SIGNUP TOKEN SUCCESS',

    SIGNUP_SUCCESS = 'SIGNUP SUCCESS',

    GET_METRICS = 'METRICS FETCHED',

    GET_ORG_SETTINGS = 'ORG SETTINGS FETCHED',

    TRANSFORMATION_DELETED = 'TRANSFORMATION DELETED',

    TRANSFORMATION_NOT_SAVED = 'TRANSFORMATION NOT SAVED',

    TRANSFORMATION_SAVE_CLICKED = 'SAVE TRANSFORMATION CLICKED',

    TRANSFORMATION_HEIGHT_MODIFIED = 'TRANSFORMATION HEIGHT MODIFIED',

    TRANSFORMATION_WIDTH_MODIFIED = 'TRANSFORMATION WIDTH MODIFIED',

    TRANSFORMATION_QUALITY_MODIFIED = 'TRANSFORMATION QUALITY MODIFIED',

    TRANSFORMATION_FORMAT_MODIFIED = 'TRANSFORMATION FORMAT MODIFIED',

    TRANSFORMATION_EFFECT_ADDED = 'TRANSFORMATION EFFECT ADDED',

    TRANSFORMATION_BLUR_MODIFIED = 'TRANSFORMATION BLUR MODIFIED',

    TRANSFORMATION_BACKGROUND_REMOVED = 'TRANSFORMATION BACKGROUND REMOVED',

    TRANSFORMATION_BACKGROUND_RESTORED = 'TRANSFORMATION BACKGROUND RESTORED',

    TRANSFORMATION_BACKGROUND_REPLACED_IMAGE = 'TRANSFORMATION BACKGROUND REPLACED IMAGE',

    TRANSFORMATION_BACKGROUND_REPLACED_COLOUR = 'TRANSFORMATION BACKGROUND REPLACED COLOUR',

    TRANSFORMATION_PADDING_ADDED = 'TRANSFORMATION PADDING ADDED',

    SCREEN_VIEWS = 'SCREEN VIEWS',

    IMAGE_COPIED = 'IMAGE COPIED',

    TRANSFORMATION_COPIED = 'TRANSFORMATION COPIED',

    ERROR = 'ERROR',

    TRANSFORMATION_FEEDBACK = 'TRANSFORMATION FEEDBACK',

    SELECT_PLAN_CLICKED = 'SELECT PLAN CLICKED',
    BILLING_DETAILS_ADD = 'BILLING DETAILS ADD',
    BILLING_DETAILS_UPDATE = 'BILLING DETAILS UPDATE',

    INVOICE_START = 'INVOICES START',
    INVOICE_PAY = 'INVOICES PAY',
    INVOICE_PAY_RZP = 'INVOICES PAY RZP',
    INVOICE_PAY_RZP_VERIFY = 'INVOICES PAY RZP VERIFY',
    INVOICE_PAY_RZP_CANCEL = 'INVOICES PAY RZP CANCEL',

    GENERIC_FEEDBACK = 'GENERIC FEEDBACK',

    MEDIA_ANNOTATIONS = 'MEDIA_ANNOTATIONS',

    QUICK_TRIAL_EVENT = 'QUICK_TRIAL_EVENT',
    MEDIA_SEARCH = 'MEDIA SEARCH',

    BACKGROUND_FILE_UPLOADED = 'BACKGROUND FILE UPLOADED',

    VIEW_PLANS_ON_ALERT = 'VIEW PLANS ON ALERT',

    SHARE_IMAGE_CLICKED = 'SHARE IMAGE CLICKED',

    SOCIAL_SHARE_CLICKED = 'SOCIAL SHARE CLICKED',

    ORG_LIST_STORAGE_SRC_SUCCESS = 'ORG LIST STORAGE SOURCES SUCCESS',
    ORG_CREATE_STORAGE_SRC_SUCCESS = 'ORG CREATE STORAGE SOURCE SUCCESS',
    ORG_UPDATE_STORAGE_SRC_SUCCESS = 'ORG UPDATE STORAGE SOURCE SUCCESS',
    ORG_DELETE_STORAGE_SRC_SUCCESS = 'ORG DELETE STORAGE SOURCE SUCCESS',

    ORG_LIST_CUSTOM_DOMAINS_SUCCESS = 'ORG LIST CUSTOM DOMAINS SUCCESS',
    ORG_GET_CUSTOM_DOMAIN_SUCCESS = 'ORG GET CUSTOM DOMAIN SUCCESS',
    ORG_ADD_CUSTOM_DOMAIN_SUCCESS = 'ORG ADD CUSTOM DOMAIN SUCCESS',
    ORG_VERIFY_CUSTOM_DOMAIN_SUCCESS = 'ORG VERIFY CUSTOM DOMAIN SUCCESS',
    ORG_UPDATE_CUSTOM_DOMAIN_SUCCESS = 'ORG UPDATE CUSTOM DOMAIN SUCCESS',
    ORG_DELETE_CUSTOM_DOMAIN_SUCCESS = 'ORG DELETE CUSTOM DOMAIN SUCCESS',

    TRANSFORMATION_FAILURE = 'TRANSFORMATION FAILURE',

    FOLDER_SHARE_CLICKED = 'FOLDER SHARE CLICKED',

    FOLDER_PERMISSION_CHANGED = 'FOLDER PERMISSION CHANGED',

    GET_WALLET_BALANCE = 'GET WALLET BALANCE',

    ADD_CREDITS_CLICKED = 'ADD CREDITS CLICKED',

    CREDITS_REDEEM_SUCCESS = 'CREDITS REDEEM SUCCESS',

    LOW_STORAGE_UPGRADE_NUDGE = 'LOW STORAGE UPGRADE NUDGE',

    CANVAS_SIZE_SET = 'CANVAS SIZE SET',

    FILE_UPLOAD_FROM_EDITOR = 'FILE UPLOAD FROM EDITOR',

    TEMPLATE_SELECTED = 'TEMPLATE SELECTED',

    ELEMENT_SELECTED = 'ELEMENT SELECTED',

    TEXTBOX_SELECTED = 'TEXTBOX SELECTED',

    LIBRARY_IMAGE_ADDED = 'LIBRARY IMAGE ADDED',

    AI_IMAGE_GENERATED = 'AI IMAGE GENERATED',

    FILTER_SELECTED = 'FILTER SELECTED',

    FONT_SELECTED = 'FONT SELECTED',

    EDITOR_EXIT = 'EDITOR_EXIT',

    SAVE_CLICKED = 'SAVE CLICKED',

    IMAGE_SAVED = 'IMAGE SAVED',

    DAYS_SINCE_JOINED = 'DAYS SINCE JOINED',
}

export enum EventProperty {
    Email = 'email',
    FirstName = 'firstName',
    LastName = 'lastName',
    FileName = 'fileName',
    FileSize = 'fileSize',
    FileType = 'fileType',
    FileUid = 'fileUid',
    FileUrl = 'fileUrl',
    ScreenName = 'screenName',
    TransformationFileUid = 'transformationFileUid',
    TransformationFileUrl = 'transformationFileUrl',
    ErrorMessage = 'errorMessage',
    ErrorTag = 'errorTag',
    ErrorStack = 'errorStack',
    Feedback = 'feedback',
    OriginalImageUrl = 'originalImageUrl',
    ModifiedImageUrl = 'modifiedImageUrl',
    Rating = 'rating',
    Country = 'country',
    ID = 'id',
    BackgroundUid = 'backgroundUid',
    BackgroundColour = 'backgroundColour',
    Width = 'width',
    Height = 'height',
    Format = 'format',
    Quality = 'quality',
    Effect = 'effect',
    SharingPlatform = 'sharingPlatform',
    FolderName = 'FolderName',
    FolderUserEmail = 'FolderUserEmail',
    FolderAccess = 'FolderAccess',
    Blur = 'Blur',
    CouponName = 'CouponName',
    Editor = 'Editor',
    TemplateName = 'TemplateName',
    Shape = 'Shape',
    TextboxType = 'TextboxType',
    AIPrompt = 'AIPrompt',
    AIStyle = 'AIStyle',
    AIDimension = 'AIDimension',
    FilterName = 'FilterName',
    FontName = 'FontName',
    LibraryImageUrl = 'LibraryImageUrl',
    ImageType = 'ImageType',
    DaysOnPixel = 'DaysOnPixel',
    Tier = 'Tier',
}

export enum ScreenNames {
    HOME_SCREEN = 'HOME SCREEN',

    MEDIA_LIBRARY = 'MEDIA LIBRARY',

    TRANSFORMATION_SCREEN = 'TRANSFORMATION SCREEN',

    QUICK_TRIAL_SCREEN = 'QUICK TRIAL SCREEN',

    PROFILE_SCREEN = 'PROFILE SCREEN',

    BILLING_PLANS_SCREEN = 'BILLING PLANS SCREEN',

    BILLING_DETAILS_SCREEN = 'BILLING DETAILS SCREEN',

    INVOICE_SCREEN = 'INVOICE SCREEN',

    IMAGE_DETAILS = 'IMAGE DETAILS',

    API_KEY = 'API KEY',

    USER_MANAGEMENT = 'USER MANAGEMENT',

    SECURITY = 'SECURITY',

    PIXEL_STUDIO = 'PIXEL STUDIO',
}

export enum ErrorTags {
    FILE_UPLOAD_ERROR = 'FILE UPLOAD ERROR',

    ORG_FILES_FETCH_ERROR = 'ORG FILE FETCH ERROR',

    MEDIA_SEARCH_ERROR = 'MEDIA SEARCH ERROR',

    DELETE_MEDIA_ERROR = 'DELETE MEDIA ERROR',

    SAVE_TRANSFORMATION_ERROR = 'SAVE TRANSFORMATION ERROR',

    DELETE_TRANSFORMATION_ERROR = 'DELETE TRANSFORMATION ERROR',

    GET_FILE_METADATA_ERROR = 'GET FILE METADATA ERROR',

    GET_SAMPLE_BACKGROUND_FILE_ERROR = 'GET SAMPLE BACKGROUND FILE ERROR',

    GET_METRICS_ERROR = 'GET METRICS ERROR',

    GET_WALLET_BALANCE_ERROR = 'GET WALLET BALANCE ERROR',

    GET_ORG_SETTINGS_ERROR = 'GET SETTINGS ERROR',

    GET_USER_PROFILE_ERROR = 'GET USER PROFILE ERROR',

    GET_ACCESS_TOKEN_ERROR = 'GET ACCESS TOKEN ERROR',

    GET_LOCAL_ACCESS_TOKEN_ERROR = 'GET LOCAL ACCESS TOKEN ERROR',

    VERIFY_SIGNUP_TOKEN_ERROR = 'VERIFY SIGNUP TOKEN ERROR',

    GOOGLE_ACCESS_TOKEN_ERROR = 'GOOGLE ACCESS TOKEN ERROR',

    SIGNUP_ERROR = 'SIGNUP_ERROR',

    LOGOUT_ERROR = 'LOGOUT ERROR',

    BILLING_PLANS_ERROR = 'BILLING PLANS ERROR',

    BILLING_DETAILS_ERROR = 'BILLING DETAILS ERROR',

    INVOICE_START_ERROR = 'INVOICE START ERROR',
    INVOICE_PAY_ERROR = 'INVOICE PAY ERROR',
    INVOICE_PAY_RZP_ERROR = 'INVOICE PAY RZP ERROR',
    INVOICE_PAY_RZP_VERIFY_ERROR = 'INVOICE PAY RZP VERIFY ERROR',

    MEDIA_ANNOTATIONS_ERROR = 'MEDIA ANNOTATIONS ERROR',
    QUICK_TRIAL_ERROR = 'QUICK TRIAL ERROR',

    GET_UNSPLASH_IMAGES_ERROR = 'GET UNSPLASH IMAGES ERROR',

    UNSPLASH_TRACKING_ERROR = 'UNSPLASH TRACKING ERROR',

    ORG_LIST_STORAGE_SRC_ERROR = 'ORG LIST STORAGE SOURCES ERROR',
    ORG_CREATE_STORAGE_SRC_ERROR = 'ORG CREATE STORAGE SOURCE ERROR',
    ORG_UPDATE_STORAGE_SRC_ERROR = 'ORG UPDATE STORAGE SOURCE ERROR',
    ORG_DELETE_STORAGE_SRC_ERROR = 'ORG DELETE STORAGE SOURCE ERROR',

    ORG_LIST_CUSTOM_DOMAINS_ERROR = 'ORG LIST CUSTOM DOMAINS ERROR',
    ORG_GET_CUSTOM_DOMAIN_ERROR = 'ORG GET CUSTOM DOMAIN ERROR',
    ORG_ADD_CUSTOM_DOMAIN_ERROR = 'ORG ADD CUSTOM DOMAIN ERROR',
    ORG_VERIFY_CUSTOM_DOMAIN_ERROR = 'ORG VERIFY CUSTOM DOMAIN ERROR',
    ORG_UPDATE_CUSTOM_DOMAIN_ERROR = 'ORG UPDATE CUSTOM DOMAIN ERROR',
    ORG_DELETE_CUSTOM_DOMAIN_ERROR = 'ORG DELETE CUSTOM DOMAIN ERROR',
}
